module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-gallery-form/product-gallery-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-gallery-form/product-gallery-form.component.scss
// module chunks = main